var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195",
    transform: "translate(-438 -440)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1017",
    "data-name": "Rectangle 1017",
    width: 20,
    height: 20,
    transform: "translate(438 440)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "call-outline",
    transform: "translate(441.705 443.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M30.435,28.111a11.107,11.107,0,0,0-2.209-1.476c-.735-.37-.8-.4-1.374.029-.386.287-.642.543-1.093.446a5.855,5.855,0,0,1-2.291-1.495A6.05,6.05,0,0,1,21.939,23.3c-.1-.45.164-.7.448-1.09.4-.545.37-.636.028-1.371a10.058,10.058,0,0,0-1.48-2.2c-.52-.514-.52-.423-.855-.284a4.847,4.847,0,0,0-.782.417,2.342,2.342,0,0,0-.941.991c-.188.4-.272,1.343.7,3.106a15.389,15.389,0,0,0,3.061,4.07,16.749,16.749,0,0,0,4.078,3.05c1.96,1.1,2.712.884,3.115.7a2.335,2.335,0,0,0,.994-.938,4.815,4.815,0,0,0,.418-.781C30.859,28.63,30.95,28.63,30.435,28.111Z",
    transform: "translate(-18.238 -18.244)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e17a61091cb78aba98ac3ac12b1d08b1.svg";
export { ForwardRef as ReactComponent };